// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__n0UVn","option":"SegmentedControl_option__n5ezi","selected":"SegmentedControl_selected__1axOs"};